import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { Query } from 'components/common/Query';
import { CATEGORIES_QUERY, PROVINCES_QUERY } from 'components/Ad/Filter';
import Filter from './Filter';

/**
 * Query to fetch durations from api
 */
export const DURATIONS_QUERY = gql`
  query {
    promotedAdPackageDurations {
      years
      months
      days
      hours
      minutes
      seconds
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class PromotedAdPackagesFilterContainer extends Component {
  constructor(props) {
    super(props);
    this.Compose = adopt({
      queryCategories: this.listCategories,
      queryProvinces: this.listProvinces,
      queryDurations: this.listDurations,
    });
  }

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listDurations = ({ render }) => (
    <Query query={DURATIONS_QUERY} variables={{}} notifyOnNetworkStatusChange>
      {({ data, loading }) => {
        const durationsData = !loading
          ? data.promotedAdPackageDurations.map(duration => {
              const { years, months, days, hours, minutes, seconds } = duration;
              return { years, months, days, hours, minutes, seconds };
            })
          : [];
        return render({ durationsData, loadingDurations: loading });
      }}
    </Query>
  );

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listCategories = ({ render }) => (
    <Query query={CATEGORIES_QUERY} variables={{}} notifyOnNetworkStatusChange>
      {({ data, loading }) =>
        render({ categoriesData: data, loadingCategories: loading })
      }
    </Query>
  );

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listProvinces = ({ render }) => (
    <Query query={PROVINCES_QUERY} variables={{}} notifyOnNetworkStatusChange>
      {({ data, loading }) =>
        render({ provincesData: data, loadingProvinces: loading })
      }
    </Query>
  );

  /**
   * @description
   * Render Filter component.
   * @returns {*} - Filter component.
   */
  render() {
    const {
      showFilters,
      showCollapseFilters,
      filter,
      appliedFilter,
      restartFilters,
    } = this.props;
    return (
      <this.Compose>
        {({
          queryCategories: { categoriesData, loadingCategories },
          queryProvinces: { provincesData, loadingProvinces },
          queryDurations: { durationsData, loadingDurations },
        }) => {
          if (loadingCategories || loadingProvinces || loadingDurations)
            return (
              <ContentLoader
                height={50}
                width={960}
                speed={2}
                primaryColor="#f3f3f3"
                secondaryColor="#e1e0e2"
              >
                <rect x="16" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="156" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="16" y="30" rx="3" ry="3" width="90" height="10" />
                <rect x="116" y="30" rx="3" ry="3" width="60" height="10" />
                <rect x="186" y="30" rx="3" ry="3" width="60" height="10" />
                <rect x="296" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="435" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="254" y="30" rx="3" ry="3" width="60" height="10" />
              </ContentLoader>
            );
          return (
            <Filter
              appliedFilter={appliedFilter}
              categories={categoriesData ? categoriesData.categories : []}
              provinces={provincesData ? provincesData.provinces : []}
              durations={durationsData}
              filter={filter}
              showFilters={showFilters}
              showCollapseFilters={showCollapseFilters}
              restartFilters={restartFilters}
            />
          );
        }}
      </this.Compose>
    );
  }
}

/**
 * PromotedAdPackagesFilterContainer PropTypes
 * @param appliedFilter - prop pass to Filter
 * @param showCollapseFilters - prop pass to Filter
 * @callback filter - prop pass to Filter
 * @callback showFilters - prop pass to Filter
 * @callback restartFilters - prop pass to Filter
 */

PromotedAdPackagesFilterContainer.propTypes = {
  appliedFilter: PropTypes.shape({}).isRequired,
  showCollapseFilters: PropTypes.bool.isRequired,
  filter: PropTypes.func.isRequired,
  showFilters: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
};

export default PromotedAdPackagesFilterContainer;
